import * as React from 'react'

type Handler = (event: MouseEvent) => void

function useClickOutside<T extends HTMLElement = HTMLElement>(
  ref: React.RefObject<T>,
  handler: Handler
): void {
  // Create a ref that stores handler
  const savedHandler = React.useRef(handler)

  // Update ref.current value if handler changes
  // This allows our effect below to always get latest handler
  savedHandler.current = handler

  React.useEffect(() => {
    const listener = (event: MouseEvent) => {
      const el = ref?.current
      if (!el || el.contains(event.target as Node)) {
        return
      }
      savedHandler.current(event)
    }
    document.addEventListener('click', listener, true)

    return () => {
      document.removeEventListener('click', listener, true)
    }
  }, [ref])
}

export default useClickOutside
